import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { JamMetadata } from '@app/models/jam.model';

export const jamActions = createActionGroup({
  source: 'Jam',
  events: {
    updateMetadata: props<{ metadata: Partial<JamMetadata> }>(),
    removeMetadataKey: props<{ key: keyof JamMetadata }>(),
    clearMetadata: emptyProps(),
  }
});